import React from "react";
import { FaMapMarkerAlt } from "react-icons/fa";

const SuburbsSection = () => {
  const suburbs = [
    "Burnside",
    "Dulwich",
    "Erindale",
    "Fullarton",
    "Glenunga",
    "Kensington",
    "Kensington Gardens",
    "Kensington Park",
    "Kingswood",
    "Leabrook",
    "Magill",
    "Malvern",
    "Marryatville",
    "Mitcham",
    "Myrtle Bank",
    "Norwood",
    "Parkside",
    "Payneham",
    "Rose Park",
    "St Peters",
    "Stepney",
    "Toorak Gardens",
    "Tranmere",
    "Trinity Gardens",
    "Unley",
    "Unley Park",
    "Wattle Park"
  ];
  

  return (
    <section className="suburbs-section py-5" style={{ backgroundColor: "#f8f9fa" }}>
      <div className="container">
        <div className="text-center mb-4">
          <h2 className="fw-bold" style={{ color: "#001070" }}>
            <FaMapMarkerAlt style={{ color: "#0a62a9", marginRight: "10px" }} />
            We Serve Multiple Zones Across Adelaide
          </h2>
        </div>

        <div className="row justify-content-center">
          <div className="col-lg-10">
            <p
              className="text-center mb-4"
              style={{
                fontSize: "1.1rem",
                lineHeight: "1.8",
                color: "#555"
              }}
            >
              We proudly deliver house cleaning services in Adelaide suburbs including:
            </p>

            {/* Suburbs List in Pills/Badges */}
            <div className="suburbs-list mt-4 mb-4">
              <div className="d-flex flex-wrap justify-content-center gap-2 gap-md-3">
                {suburbs.map((suburb, index) => (
                  <span
                    key={index}
                    className="badge px-2 px-sm-3 py-1 py-sm-2"
                    style={{
                      backgroundColor: "#e3f2fd",
                      color: "#0a62a9",
                      fontSize: "0.8rem",
                      fontWeight: "500",
                      borderRadius: "15px",
                      border: "1px solid #0a62a9",
                      display: "inline-block",
                      whiteSpace: "nowrap",
                      textAlign: "center",
                      lineHeight: "1.5"
                    }}
                  >
                    {suburb}
                  </span>
                ))}
              </div>
            </div>

            {/* Call to Action Box */}
            {/* <div className="text-center mt-5">
              <div
                className="p-4"
                style={{
                  backgroundColor: "#e3f2fd",
                  borderRadius: "15px",
                  border: "2px solid #0a62a9"
                }}
              >
                <h5 className="fw-bold" style={{ color: "#001070" }}>
                  Not listed above?
                </h5>
                <p className="mb-3" style={{ color: "#555" }}>
                  Contact our friendly team — we likely clean in your area too!
                </p>
                <a
                  href="/contact-us"
                  className="btn btn-primary px-5 py-2"
                  style={{
                    borderRadius: "30px",
                    backgroundColor: "#0a62a9",
                    border: "none"
                  }}
                >
                  Contact Us
                </a>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SuburbsSection;
